import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { Balances } from "./Balances";
import styles from "./styles.pcss";
import { BonusBalanceModal } from "./BonusBalanceModal";
var cn = classNames.bind(styles);
export var BalancesSelect = function BalancesSelect(_ref) {
  var children = _ref.children,
    showBalances = _ref.showBalances,
    onClickOutside = _ref.onClickOutside;
  var containerRef = useRef(null);
  var childrenWrapperRef = useRef(null);
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('container'),
    ref: containerRef,
    "data-t-id": "components-BalancesSelect"
  }, /*#__PURE__*/React.createElement("div", {
    ref: childrenWrapperRef
  }, children), showBalances && /*#__PURE__*/React.createElement(Balances, {
    isMobile: isMobile,
    onClickOutside: onClickOutside,
    parentRef: containerRef,
    siblingRef: childrenWrapperRef
  })), /*#__PURE__*/React.createElement(BonusBalanceModal, null));
};